import Airtable from 'airtable'

// Andy Longacre personal-access token generated March 2024
Airtable.configure({apiKey: 'patxIzMgtpt7loJvK.fe0e79691ced783916ffcbe5231135bb0695b3485259c5340a2e2c0e6905d210'})

// IGNORE NEXT COMMENT
// airtable base ID grabbed from docs (https://airtable.com/appGBhqIiZrXcVq7R/api/docs#javascript/introduction)

// USING FAKE BASE
export const base = Airtable.base('appGBhqIiZrXcVq7R')

const Filter = {
  and: (f1, f2) => `AND(${f1},${f2})`
}

// create filter for many record select
const buildMultiRecordFilter = ids =>
  'OR( ' +
    ids.reduce(((c, s, i) => (
      c + 
      `(RECORD_ID() = '${s}'` + 
      ((i < ids.length-1)?'),':')'))), '') +
  ')';

// get all records with ids in a list
const queryAll = (table, ids, opts) => table.select({
  ...opts,
  filterByFormula: opts.filterByFormula ? Filter.and(opts.filterByFormula, buildMultiRecordFilter(ids)) : buildMultiRecordFilter(ids)
})

export const toJS = rec => ({id: rec.id, ...rec.fields})

export const getAll = (table, ids) => new Promise((res, rej) => {
  if (ids === null || ids === undefined || !ids.length) { res([]); return; }
  const recs = [];
  queryAll(base(table), ids, { view: 'Grid view' }).eachPage((records, next) => {
    console.log(records)
    recs.push(...records.map(toJS));
    next()
  }, err => {
    console.log(recs);
    if(err){ rej(err) }
    else {
      res(recs)
    }
  })
})
